const Hero = () => {
  return (
    <section className="relative bg-white overflow-hidden py-24 md:py-32 lg:py-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold tracking-tighter leading-tight mb-8 opacity-0 animate-fade-in-up">
            Simple.<br />
            Smart.<br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-gray-900 to-gray-500">
              Ahead.
            </span>
          </h1>
          <p
            className="mt-6 text-xl md:text-2xl text-gray-500 font-light max-w-2xl mx-auto opacity-0 animate-fade-in-up"
            style={{ animationDelay: '0.2s' }}
          >
            Intelligence. Anytime. Anywhere.
          </p>
          <div
            className="mt-10 flex justify-center gap-4 opacity-0 animate-fade-in-up"
            style={{ animationDelay: '0.4s' }}
          >
            <a
              href="#about"
              className="px-8 py-4 text-base font-semibold text-white bg-black rounded-full hover:bg-gray-800 transition-all shadow-lg hover:shadow-xl"
            >
              Who We Are
            </a>
            <a
              href="#stack"
              className="px-8 py-4 text-base font-semibold text-gray-900 bg-white border-2 border-gray-300 rounded-full hover:bg-gray-50 hover:border-gray-400 shadow-md hover:shadow-lg transition-all"
            >
              Our Stack
            </a>
          </div>
        </div>
      </div>

      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gradient-to-tr from-blue-50 to-gray-50 rounded-full blur-3xl -z-10 opacity-60 pointer-events-none"></div>
    </section>
  )
}

export default Hero
